<div class="wrapper">
  <div [innerHtml]="'app.conditions.text' | i18n" class="doc"></div>
</div>
